<template>

</template>

<script>
    import ss from '../api/SystemService';
    import store from "../store";
    export default {
        data(){
            return {
                url: 'http://omstest.haierbiomedical.com/dingd/orderNxSend',
            }
        },
        created() {
            this.loading = true;
            this.toRescue();
        },
        methods: {
            toRescue() {
                var userCode = this.$route.query.userCode;
                var tokenId = this.$route.query.tokenId;
                ss.UserAuthService.getSingleUserInfoToken(userCode,tokenId).then(rd => {
                    if(rd.f == true){
                        store.commit("setUser", rd)
                        this.loading = false;
                        this.$router.push({path: rd.obj.defaultpage});
                    }
                })
            },
        },
    }
</script>

<style scoped>

</style>
